<template>
    <div class="wrapper">
        <div class="page-header page-header-small">
            
            <div class="content-center">
                <div class="row">
                    <div class="col-10 ml-auto mr-auto">
                        <h2>Vývoj responzivních single page webových aplikací na platformě</h2>
                        <h1 class="title maxtitle">Vue</h1>
                        <h1 class="title maxtitle">Python</h1>
                        <h1 class="title maxtitle">PostgreSQL</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="section">

            <div class="">
                <div class="container">
                    <div class="row transparent">
                        <div class="col-md-8 mr-auto ml-auto">
                            <h2 class="text-center title">Jsme vám k dispozici na:</h2>
                            <h5 class="text-center description"><i class="fas fa-phone-alt nav-icon"></i> +420 734 786 999</h5>
                            <h5 class="text-center description"><i class="fas fa-at nav-icon"></i> info@hippoware.cz</h5>
                            <h5 class="text-center description"><i class="far fa-envelope nav-icon"></i> Na Kopečku 3439/15, 400 01 Ústí nad Labem</h5>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { Button, FormGroupInput, Checkbox } from '@/components';
  import { Select, Option } from 'element-ui'

  export default {
    name: 'about-us',
    bodyClass: 'about-us',
    components: {
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
        form: {
          name: '',
          email: '',
          phone: ''
        },
        imgSrc: "img/card_8145342.jpg"
      }
    }
  }
</script>
<style>
.section {
    padding: 0 0 !important;
}

.about-us {
    padding: 0 0 !important;
}
.about-description, .about-contact {
    padding: 0 0 !important;
}        
.features-3 {
    padding: 0 0 !important;
}        
.description {
    color: #888 !important;
    font-weight: 500 !important;
}       
.maxtitle {
    color: white !important;
    font-size: 50px !important;
    font-weight: 900 !important;
    padding-top: 0px !important;
}    
.vytahnout {
    margin-top: -8vh;
}    

.section {
    opacity: 0.7;
}
</style>
